import React from "react";
import "./otp.scoped.css";
import logo from "../assets/img/logo.png";
import { useDispatch } from "react-redux";
import { resendCodeAPI, verifyCodeAPI } from "../service/AuthService";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { resetChallengeModalForLogin } from "../utils/pinnedChallengeUsers";

export default function Otp() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = location?.state?.userName;
  const mfaChannel = location?.state?.mfaChannel || "TELEGRAM";
  const [isVerifying, setIsVerifying] = React.useState(false);
  const [otp, setOtp] = React.useState(() => Array.from({ length: 6 }, () => ({ value: "", ref: React.createRef() })));

  const verify = async (code) => {
    if (isVerifying || code.length !== 6) return;
    setIsVerifying(true);
    const result = await verifyCodeAPI(userName, code);
    if (result?.code === 200) {
      if (result?.response?.token) localStorage.setItem("token", result.response.token);
      dispatch({ type: "accountData/setUserData", payload: result.response });
      toast.success("Login successful");
      resetChallengeModalForLogin();
      navigate("/admin/market-analysis", { replace: true });
    } else {
      toast.error(result?.response?.data?.response || result?.response || "Invalid OTP");
      setOtp((current) => current.map((item) => ({ ...item, value: "" })));
      otp[0].ref.current?.focus();
    }
    setIsVerifying(false);
  };

  const changeOtp = (event, index) => {
    const value = event.target.value.replace(/\D/g, "").slice(-1);
    const next = otp.map((item, itemIndex) => itemIndex === index ? { ...item, value } : item);
    setOtp(next);
    if (value && index < 5) next[index + 1].ref.current?.focus();
    const code = next.map((item) => item.value).join("");
    if (index === 5 && code.length === 6) verify(code);
  };

  const keyDown = (event, index) => {
    if (event.key === "Backspace" && !otp[index].value && index > 0) {
      const next = otp.map((item, itemIndex) => itemIndex === index - 1 ? { ...item, value: "" } : item);
      setOtp(next);
      next[index - 1].ref.current?.focus();
    }
  };

  const resend = async (event) => {
    event.preventDefault();
    const result = await resendCodeAPI(userName);
    result?.code === 200 ? toast.success("Code sent successfully") : toast.error(result?.response?.data?.response || result?.response || "Unable to resend code");
  };

  const isTelegram = mfaChannel === "TELEGRAM";
  return <main className="otp-screen">
    <section className="otp-panel">
      <img className="otp-logo" src={logo} alt="OEXCH" />
      <h1>Security Code Verification Using {isTelegram ? "Telegram App" : "Authenticator App"}</h1>
      <p>Enter 6-digit code from your {isTelegram ? "telegram bot" : "authenticator app"}{isTelegram && <> <a href="#resend" onClick={resend}>Resend Code</a></>}</p>
      <div className="otp-boxes" aria-label="One time password">
        {otp.map((item, index) => <input key={index} ref={item.ref} inputMode="numeric" autoComplete={index === 0 ? "one-time-code" : "off"} maxLength={1} value={item.value} disabled={isVerifying} onChange={(event) => changeOtp(event, index)} onKeyDown={(event) => keyDown(event, index)} />)}
      </div>
    </section>
  </main>;
}
